
    import { Component, Prop, Watch, mixins } from 'nuxt-property-decorator';
    import { namespace } from 'nuxt-property-decorator';
    import ImageComponent from '@/components/blocks/ImageComponent.vue';
    import HandleResultMixin, { HandleType } from '@/mixins/handleResultMixin';

    const editor = namespace('editor');

    @Component({
        components: { ImageComponent }
    })
    export default class OptionsFieldsGalleryImage extends mixins(HandleResultMixin) {
        @Prop() title;
        @Prop() value!: any;
        @Prop() keyOption;
        @Prop() onlyFile;
        @editor.Mutation setComponent;
        @editor.Action loadFile;
        @editor.Action resizeFile;
        @editor.Action savePage;

        async saveAction() {
            const result = await this.savePage();
            this.handleResult(result, HandleType.Toast);
        }

        image = {
            ...this.value,
            size: this.value && this.value.size ? this.value.size : '362x362'
        };

        @Watch('image', { immediate: true, deep: true })
        onImageChanged(val, oldVal) {
            this.$emit('input', val);
        }

        @Watch('value', { immediate: true, deep: true })
        onValueChanged(val, oldVal) {
            if (oldVal && val && val.src !== oldVal.src) {
                this.image = val;
            }
        }

        async resizeImage() {
            const response = await this.resizeFile({ image: this.image });
            this.image.thumbnail = response.thumbnail + '?' + new Date().getTime();

            this.saveAction();
        }

        async change(file) {
            const data = new FormData();
            data.append('file', file, file.name);
            data.append('isOnEdit', 'true');
            data.append('isOnPublish', 'false');
            data.append('pageId', this.$route.params.id);
            const payload = { data, image: this.image };
            const response = await this.loadFile(payload);
            this.image.src = response['file'];
            this.image.thumbnail = response['thumbnail'];
            this.image.small = response['small'];
            this.image.medium = response['medium'];
        }

        set file(file) {
            this.change(file);
        }

        get file() {
            return '';
        }

        clearImage() {
            this.image = {
                src: '',
                thumbnail: '',
                title: '',
                alt: '',
                margin: false,
                size: '362x362',
                small: ''
            };
        }

        get values() {
            return [
                {
                    text: '362x362',
                    value: '362x362',
                    selected: true
                },
                {
                    text: '362x204',
                    value: '362x204'
                },
                {
                    text: '166x166',
                    value: '166x166'
                }
            ];
        }

        get isVideo() {
            return this.image.src.indexOf('.mp4') !== -1;
        }
    }
